import { Injectable } from '@angular/core';

function getWindow(): any {
  return window ?? new Window();
}

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  get window(): any {
    return getWindow();
  }

  goBack() {
    this.window.history.back();
  }
}
